import { render } from "./active-coupons.vue?vue&type=template&id=4d2a6dc6"
import script from "./active-coupons.vue?vue&type=script&lang=js"
export * from "./active-coupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__